import type { ComponentProps } from 'react';

import { chain } from 'lodash';

import { Summary as SubscriptionsSummary } from '@admin/components/subscriptions/summary';
import type { ISubscription } from '@admin/types/subscription';

export type SubscriptionSummaryList = NonNullable<ComponentProps<typeof SubscriptionsSummary>['subscriptions']>;

export const storageSubscriptions = (subscriptions: ISubscription[] = []): SubscriptionSummaryList =>
  chain(subscriptions)
    .filter((subscription) => subscription.plan?.type === 'StoragePlan')
    .sortBy('plan.id')
    .value() as unknown as SubscriptionSummaryList;

export const protectionSubscriptions = (subscriptions: ISubscription[] = []): SubscriptionSummaryList =>
  chain(subscriptions)
    .filter((subscription) => subscription.plan?.type === 'ProtectionPlan')
    .sortBy('plan.id')
    .value() as unknown as SubscriptionSummaryList;
